const HERO_SLIDE_COUNT = 4
const HERO_SLIDE_BASE = '/assets/black-gold'

export function getHeroSlidePrefix (locale) {
  return String(locale || 'ko').toLowerCase() === 'ko' ? 'ko' : 'en'
}

export function getHeroSlides (locale) {
  const prefix = getHeroSlidePrefix(locale)
  return Array.from({ length: HERO_SLIDE_COUNT }, (_, index) => (
    `${HERO_SLIDE_BASE}/${prefix}_${index}.png`
  ))
}

export function resolveBannerSlideUrls (bannerList) {
  return (Array.isArray(bannerList) ? bannerList : [])
    .map(item => (item && item.img_url != null ? String(item.img_url).trim() : ''))
    .filter(Boolean)
}

export function resolveHeroSlides (bannerList, locale) {
  void locale
  return resolveBannerSlideUrls(bannerList)
}
